import * as React from "react";
import StoreDetailImage from "./StoreDetailImage.js";
const StoreDetailImageContainer = ({
  alt,
  detailImageUrl,
  fallbackImage,
  ...rest
}) => {
  const url = detailImageUrl || fallbackImage?.url;
  if (!url) {
    return null;
  }
  const altText = !detailImageUrl ? fallbackImage?.description ?? alt : alt;
  return /* @__PURE__ */ React.createElement(
    StoreDetailImage,
    {
      ...rest,
      storeDetailImageUrl: url,
      isFallbackImage: !detailImageUrl,
      width: !detailImageUrl ? fallbackImage?.width : void 0,
      height: !detailImageUrl ? fallbackImage?.height : void 0,
      alt: altText
    }
  );
};
export {
  StoreDetailImageContainer as default
};
//# sourceMappingURL=StoreDetailImageContainer.js.map
